import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const SuperAdminTenantViewSchema: Types.ViewSchemaType<GQL.TenantFragment> = {
    enums: [
        {
            label: "Status",
            field: "tenant_status",
            type: "tenant-status-badge",
            relation_field: "display"
        },
        {
            label: "Type",
            field: "tenant_type",
            type: "tenant-type-badge",
            relation_field: "display"
        }
    ],
    fields: [
        {
            label: "Tenant Number",
            field: "tenant_number",
            type: "number"
        },
        {
            label: "Name",
            field: "name",
            type: "text"
        },
        {
            label: "Address Line1",
            field: "address_line1",
            type: "text"
        },
        {
            label: "Address Line2",
            field: "address_line2",
            type: "text"
        },
        {
            label: "City",
            field: "city",
            type: "text"
        },
        {
            label: "State",
            field: "state",
            type: "text"
        },
        {
            label: "Country",
            field: "country",
            type: "text"
        },
        {
            label: "Postal Code",
            field: "postal_code",
            type: "text"
        },
        {
            label: "Phone",
            field: "phone",
            type: "text"
        },
        {
            label: "Instagram",
            field: "instagram",
            type: "text"
        },
        {
            label: "Website",
            field: "website",
            type: "text"
        },
        {
            label: "Logo",
            field: "logo",
            type: "text"
        },
        {
            label: "Anniversary",
            field: "anniversary",
            type: "date"
        },
        {
            label: "Deleted",
            field: "deleted",
            type: "boolean"
        },
        {
            label: "Poc",
            field: "poc",
            type: "text"
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        },
        {
            label: "Timezone",
            field: "timezone",
            type: "text"
        }
    ],
    relations: {
        created_by_user: {
            relation: "created_by_user",
            label: "Created By User",
            fields: [
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "user_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Role",
                    field: "user_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Timezone",
                    field: "timezone",
                    type: "text"
                }
            ]
        },
        updated_by_user: {
            relation: "updated_by_user",
            label: "Updated By User",
            fields: [
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "user_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Role",
                    field: "user_type",
                    type: "text",
                    relation_field: "display"
                },
                {
                    label: "Timezone",
                    field: "timezone",
                    type: "text"
                }
            ]
        }
    }
}